window.addEventListener("load", (e) => {
  const DatePicker = window.tui.DatePicker;
  let datePickerEl = document.getElementById("jsDatePicker"),
  datePickerContainerEl = document.getElementById("jsDatePickerContainer");

  if (datePickerEl && datePickerContainerEl) {
    let datePicker = new DatePicker(datePickerContainerEl, {
      input: {
        element: datePickerEl,
      },
      date: new Date(),
    });
    datePicker.setDateFormat("yyyy/MM/dd");
  }

});
